import script from "./HoverSim.vue?vue&type=script&setup=true&lang=js"
export * from "./HoverSim.vue?vue&type=script&setup=true&lang=js"

import "./HoverSim.vue?vue&type=style&index=0&id=4532a1a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4532a1a1"]])

export default __exports__